













































































import permissionGroup from '@/store/types/permissionGroup';
import {
  PermissionGroupParams
} from '@/store/interfaces/PermissionGroup';
import viewPermissionModal from '@/components/Permissions/viewPermissionModal.vue';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'Permissions',
  components: {
    viewPermissionModal,
  },
  data: () => ({
    kind: 2,
    showModal: false,
    rowselect: {},
    kindOptions: [
      {
        name: 'Todos',
        id: 2,
      },
      {
        name: 'De personal',
        id: 0,
      },
      {
        name: 'De compañia',
        id: 1,
      }
    ] as {name: string, id: number}[],
    propsToSearch: [] as tPropsToSearch,
    tableColumns: [
      {
        prop: 'name',
        label: 'Grupo',
        minWidth: 250,
        sortable: true,
      },
      {
        prop: 'virtual_permission_count',
        label: 'Total permisos asignados',
        minWidth: 250,
      },
      {
        prop: 'kind',
        label: 'Tipo',
        minWidth: 100,
        formatter: (row: PermissionGroupParams) => {
          return row.kind === 'staff' ? 'Personal' : 'Compañía';
        },
      }
    ] as tTableColumns,
  }),
  computed: {
    ...mapGetters({
      getPermissionGroupList: `permissionGroupModule/${permissionGroup.getters.GET_PERMISSIONS_GROUP_LIST}`,
    }),
    kindSearch(): string {
      return this.$data.kind === 0
        ? '&kind_eq=0'
        : this.$data.kind === 1
          ? '&kind_eq=1'
          : '';
    },
  },
  methods: {
    ...mapActions({
      permissionGroupList: `permissionGroupModule/${permissionGroup.actions.PERMISSION_GROUP_LIST}`,
    }),
    permissionSelect(permission: PermissionGroupParams): void {
      this.$data.rowselect = permission;
    },
    newGroup(): void {
      this.$router.push({
        name: 'new-group-permission',
      });
    },
    editPermission(): void {
      this.$router.push({
        name: 'edit-group-permission',
        params: {
          permission_id: this.$data.rowselect.id,
        },
      });
    },
  },
});

